<template>
  <Modal :title="title" :showModal="showModal" class="design-idea-template-modal design-idea-form view">
    <template v-slot:body>
      <div class="d-flex design-idea-container">
        <div class="left-sidebar scrollbar overflow-x-hidden overflow-auto p-3">
          <template v-if="more.can_action">
            <Status :config="data" @submitStatus="submitStatus"></Status>
            <hr />
          </template>
          <div class="position-relative form-group w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Name*</label>
            <p class="item mt-2">{{ data.name }}</p>
          </div>
          <div class="position-relative form-group w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">
              <span>SKU</span>
              <i class="ti ti-printer ml-2 print-content" @click="handlePrint"></i>
            </label>
            <p class="item mt-2">{{ data.sku }}</p>
          </div>
          <div class="position-relative form-group w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Description*</label>
            <div class="item mt-2" v-html="handleDescription(data.description)"></div>
          </div>
          <div class="position-relative form-group category w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Category*</label>
            <div v-for="(term, index) in data.terms" :key="index" class="item mr-2 mt-2 ml-2">
              <label class="mb-0">
                <strong>{{ term.name }}</strong>
              </label>
              <p class="title mb-0">
                Title:
                <span class="select-all">{{ data?.mockups?.[term.id]?.title || '-' }}</span>
              </p>
              <p class="tags mb-1">
                Tags:
                <span class="select-all">{{ $_.isObjectLike(data?.mockups?.[term.id]?.tags) ? Object.values(data.mockups[term.id].tags).join(', ') : '-' }}</span>
              </p>
            </div>
          </div>
          <div class="position-relative form-group w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Tags<i class="ti ti-copy ml-2 copy-file" @click="copyToClipboard"></i></label>
            <p class="item mt-2">
              <template v-for="(tag, index) in data.tags" :key="index">
                <span class="tag mb-2">{{ tag }}</span>
                <span class="comma">,&nbsp;</span>
              </template>
            </p>
          </div>
          <div class="position-relative form-group clearfix w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Samples*</label>
            <template v-for="(sample, index) in data.samples" :key="index">
              <p class="item mt-2">
                <a :href="sample" target="_blank">{{ sample }}</a>
              </p>
            </template>
          </div>
          <div class="position-relative form-group clearfix w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Idea creator</label>
            <p class="item mt-2">{{ data.user_name }}</p>
          </div>
          <div class="position-relative form-group clearfix w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Designer</label>
            <p class="item mt-2">{{ data.designer_name }}</p>
          </div>
          <div class="position-relative form-group clearfix w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Status</label>
            <p class="item mt-2">
              {{ more.statuses[data.status] ? more.statuses[data.status].label : data.status }}
            </p>
          </div>
          <div class="position-relative form-group clearfix w-100">
            <label class="col-12 mb-0 p-0 font-weight-bold">Priority</label>
            <p class="item mt-2">
              {{ data?.priority > 0 ? more?.priority?.[data?.priority]?.text : 'Default' }}
            </p>
          </div>
        </div>
        <div class="main-design-idea main-thumbnail-preview">
          <Gallery :value="galleryConfig.gallery" :groups="galleryConfig.groups" :config="galleryConfig.config">
            <template #before-footer-container>
              <div v-if="Object.keys(data.mockups).length > 0 && data.status != 'mockup-review'" class="edit-mockup-form hide" ref="edit_url_mockup_form">
                <div class="position-relative form-group">
                  <input class="form-control flex-1 form-input" type="text" placeholder="Url" />
                  <button type="submit" class="btn btn-primary" @click="submitUpdateProductUrl">Save</button>
                  <button type="submit" class="btn btn-light" @click="$refs.edit_url_mockup_form.classList.add('hide')">Cancel</button>
                </div>
              </div>
            </template>
            <template #thumbnail-before-container="object">
              <template v-if="object.args?.group?.label.startsWith('Mockup')">
                <label v-if="object.args?.group?.term_id" :class="`${data.status == 'mockup-review' && parseInt(object.args?.group?.latest) == 1 ? 'latest' : ''} ${parseInt(object.args?.group?.reject) == 1 ? 'reject' : ''}`">
                  <strong>{{ terms[object.args?.group?.term_id].name ?? '' }}</strong>
                  <i class="ti ti-star-filled latest"></i>
                  <i class="ti ti-eraser reject"></i>
                </label>
                <ul class="list-action break-normal">
                  <li v-show="object.args?.group?.list" class="action-link">
                    <div class="icon">
                      <a :href="object.args?.group?.list" target="_blank"><i class="ti ti-link"></i></a>
                    </div>
                  </li>
                  <li v-show="data.status != 'mockup-review'" class="action-edit">
                    <div class="icon" @click="editProductUrl($event, object.args?.group?.term_id)">
                      <i class="ti ti-edit"></i>
                    </div>
                  </li>
                  <li class="action-download position-relative" ref="downloadMockup">
                    <div class="icon" @click="downloadMockup($event, object.args?.group?.term_id)"><i class="ti ti-cloud-down"></i><i class="icon-loading"></i></div>
                  </li>
                </ul>
              </template>
            </template>
          </Gallery>
        </div>
        <div class="right-sidebar scrollbar overflow-x-hidden overflow-auto p-3">
          <Comment :config="data"></Comment>
        </div>
      </div>
    </template>
    <template v-slot:footer><span></span></template>
  </Modal>
</template>

<script>
import FileSaver from 'file-saver'
import Event from '@/helper/event.js'
import Gallery from '@/components/Gallery.vue'
import Status from './Status.vue'
import Comment from './Comment.vue'
import JSZip from 'jszip'
import print from '@/helper/print.js'

export default {
  mixins: [Event],
  components: {
    Gallery,
    Status,
    Comment
  },
  data() {
    return {
      modal: false,
      collapse: false,
      selectedGallery: {
        type: 'thumbnails',
        index: 0
      },
      data: {
        samples: [''],
        mockups: {}
      },
      zipWriter: null,
      contentType: {
        'image/gif': 'gif',
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/tiff': 'tiff',
        'image/vnd.wap.wbmp': 'wbmp',
        'image/x-icon': 'ico',
        'image/x-jng': ' jng',
        'image/x-ms-bmp': 'bmp',
        'image/svg+xml': 'svg',
        'image/webp': 'webp'
      }
    }
  },
  computed: {
    title() {
      return 'View Idea'
    },
    action() {
      return 'view'
    },
    storeId() {
      return this.config?.storeId
    },
    designIdeaId() {
      return this.config?.data?._id
    },
    getUri() {
      return `design-idea/get/${this.designIdeaId}`
    },
    galleryConfig() {
      let groups = {
        gallery: {
          label: 'Gallery',
          priority: 10
        },
        blueprint: {
          label: 'Blueprint',
          priority: 15
        },
        artwork: {
          label: 'Artwork',
          priority: 12
        }
      }
      let gallery = []
      Object.values(this.data.thumbnails || []).forEach((value, index) => {
        gallery.push({
          items: value?.files || value,
          status: value?.status || null,
          uploaded: value?.uploaded || false,
          index,
          group: 'gallery',
          name: this.data?.sku || null
        })
      })
      Object.values(this.data.designs || []).forEach((value, index) => {
        gallery.push({
          items: value?.files || value,
          status: value?.status || null,
          uploaded: value?.uploaded || false,
          index,
          group: 'blueprint',
          name: this.data?.sku || null
        })
      })
      Object.values(this.data.artworks || []).forEach((value, index) => {
        gallery.push({
          items: value?.files || value,
          status: value?.status || null,
          uploaded: value?.uploaded || false,
          index,
          group: 'artwork',
          name: this.data?.sku || null
        })
      })
      Object.values(this.data.mockups || []).forEach((items, key) => {
        groups[`mockup-${items.term_id}`] = {
          label: `Mockup ${items.term_id}`,
          index: key,
          priority: 20,
          term_id: items.term_id,
          latest: items.latest,
          reject: items.reject,
          name: this.data?.sku || null
        }
        Object.values(items?.attachments || []).forEach((value, index) => {
          gallery.push({
            items: value?.files || value,
            status: value?.status || null,
            uploaded: value?.uploaded || false,
            index,
            group: `mockup-${items.term_id}`,
            name: this.data?.sku || null
          })
        })
      })
      return {
        gallery,
        groups,
        config: {
          fullScreen: true,
          background: true,
          thumbnail: true,
          editable: false,
          showLabel: true,
          default: {
            selected: {
              group: 'gallery'
            }
          }
        }
      }
    },
    // imagePreview() {
    //   let images = []
    //   let imagesObject = this.data?.[this.selectedGallery.type] || {}
    //   if (this.selectedGallery?.type == 'mockups') {
    //     images = imagesObject?.[this.selectedGallery.parent]?.['attachments']?.[this.selectedGallery.index] || []
    //   } else {
    //     images = imagesObject?.[this.selectedGallery.index] || []
    //   }

    //   if (_.isString(images)) {
    //     return [images]
    //   } else if (_.isObjectLike(images)) {
    //     if (_.isObjectLike(images.files) || _.isObjectLike(images.urls)) {
    //       return images.files || images.urls
    //     } else if (_.isArray(images) && Object.keys(images).length > 0) {
    //       return images
    //     }
    //   }
    //   return [defaultThumbnailImage]
    // },
    terms() {
      let terms = {
        '': {
          name: ''
        }
      }
      Object.values(this.data.terms || []).forEach((item) => {
        terms[item.id] = item
      })
      return terms
    },
    more() {
      return Object.assign(
        {
          statuses: {}
        },
        this.data.more
      )
    }
  },
  created() {
    this.store.commit(['data'], {})
    this.selectedGallery = {
      type: 'thumbnails',
      parent: 0,
      index: 0
    }
  },
  methods: {
    handlePrint() {
      print.designIdea([this.data])
    },
    handleDescription(text) {
      return this.$util.linkify((text || '').replace(/\n/g, '<br>'))
    },
    showPreviewImages(type) {
      if (!this.collapse) {
        return true
      }

      if (['mockup-rejected', 'listing', 'mockup-review', 'completed'].indexOf(this.data.status) != -1) {
        this.selectedGallery.type = 'mockups'
      } else if (['design-rejected', 'design-review', 'create-mockup', 'listing'].indexOf(this.data.status) != -1) {
        this.selectedGallery.type = 'designs'
      } else if (['un-assigned', 'confirm', 'doing', 'denied'].indexOf(this.data.status) != -1 || ['create', 'edit'].indexOf(this.action) != -1) {
        this.selectedGallery.type = 'thumbnails'
      }

      if (!this.collapse) {
        return true
      }
      return this.selectedGallery.type == type
    },
    changePreviewImages(type) {
      this.selectedGallery = {
        type: type,
        parent: this.$refs.thumbnailList.querySelector('input:checked').getAttribute('data-index') || 0,
        index: this.$refs.thumbnailList.querySelector('input:checked').value
      }
    },
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.data.tags.join(', '))
        .then(() => {
          this.$util.notify({
            status: 'success',
            text: 'Text copied'
          })
        })
        .catch(() => {
          this.$util.notify({
            status: 'success',
            text: 'Could not copy tags!'
          })
        })
    },
    editProductUrl(e, term_id) {
      this.$refs.edit_url_mockup_form.classList.remove('hide')
      this.$refs.edit_url_mockup_form.setAttribute('data-index', term_id)
      this.$refs.edit_url_mockup_form.querySelector('.form-input').value = this.data.mockups?.[term_id]?.list || ''
    },
    submitUpdateProductUrl() {
      let data = {
        type: 'href',
        term_id: this.$refs.edit_url_mockup_form.getAttribute('data-index'),
        values: this.$refs.edit_url_mockup_form.querySelector('.form-input').value
      }

      this.updateMockups(this.$refs.edit_url_mockup_form, data)
    },
    updateMockups(el, data) {
      this.$util
        .post(`design-idea/update-mockup/${this.designIdeaId}`, data, el)
        .then((response) => {
          if (response.status == 'success') {
            el.classList.add('hide')
            this.refreshData(response.data)
          } else {
            console.log(response)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async downloadMockup(e, term_id) {
      let promises = []
      let $downloadMockup = e.target.closest('.thumbnail-preview-container').querySelector('.icon-loading')

      if (Object.keys(this.data.mockups).length == 0) {
        alert('No mockups uploaded yet')
      } else {
        let zip = new JSZip()
        $downloadMockup.style.display = 'block'
        let fileContent = `Title: ${this.data.mockups[term_id]?.title || ''}\nTags: ${Object.values(this.data.mockups[term_id]?.tags || []).join(', ')}`
        Object.values(this.data.mockups[term_id]?.attachments).forEach((url) => {
          if (Object.values(this.contentType).includes(this.$util.getExtensionFromString(url))) {
            promises.push(
              new Promise((resolve) => {
                fetch(url)
                  .then((data) => data.blob())
                  .then((blob) => resolve(blob))
              })
            )
          }
        })

        Promise.all(promises).then(async (values) => {
          Object.values(values).forEach((file, i) => {
            zip.file(`mockup-${this.terms[term_id].name || 'default'}-${i}.jpg`, file)
          })
          zip.file('Summary.txt', fileContent)
          zip.generateAsync({ type: 'blob' }).then((blob) => {
            FileSaver.saveAs(blob, `Mockup-${this.terms[term_id].name || 'default'}-${this.data.id}.zip`)
          })
          $downloadMockup.style.display = 'none'
        })
      }
    },
    setUpData({ status, data }) {
      if (status == 'success') {
        this.showModal = true
        if (Object.keys(data.samples).length == 0) {
          data.samples = ['']
        }
        data.mockups = this.$util.map(Object.assign({}, data.mockups), ({ item }) => {
          return Object.assign(
            {
              term_id: '',
              title: '',
              attachments: {},
              latest: 0,
              tags: []
            },
            item
          )
        })
        this.refreshData(data)
      }
    },
    submitStatus(data) {
      this.refreshData(data)
    },
    refreshData(data) {
      this.data = data
      let mockups = {}
      Object.values(this.data.mockups).forEach((item, key) => {
        mockups[item.term_id || key] = item
      })
      this.data.mockups = mockups
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.table-container {
  width: 100%;
}
.design-idea-template-modal {
  &.view {
    .modal-footer {
      display: none;
    }
  }
  .modal-dialog {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    padding: 0;
    margin: 0;
    border: 0;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
    .modal-body {
      padding: 0px !important;
    }
  }
  .design-idea-container {
    height: 100%;
  }
  .main-thumbnail-preview,
  .left-sidebar,
  .right-sidebar {
    width: 300px;
    padding: 0;
    background: #fff;
    z-index: 9;
    height: calc(100vh - 64px);
  }
  .left-sidebar {
    border-right: 1px solid #dfdfdf;
    .item {
      margin-bottom: 0;
      .tag {
        background: #ddd;
        padding: 5px 7px;
        border-radius: var(--border-radius, 0.25rem);
        display: inline-block;
        line-height: 1;
      }
      .comma {
        opacity: 0;
        &:last-child {
          display: none;
        }
      }
    }
    .copy-file {
      font-size: 18px;
      bottom: -2px;
      position: absolute;
      background: #efefef;
      border: 1px solid #ccc;
      border-radius: var(--border-radius, 0.25rem);
      padding: 2px 10px;
      opacity: 0.5;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
    .category {
      .item {
        label {
          font-size: 13px;
        }
      }
    }
  }
  .right-sidebar {
    border-left: 1px solid #dfdfdf;
  }
  .main-thumbnail-preview {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    overflow: hidden;
    .toggle-collapse {
      position: absolute;
      bottom: 100%;
      right: 20px;
      width: 30px;
      height: 30px;
      z-index: 999999;
      cursor: pointer;
      display: none;
      border: 1px solid #dfdfdf;
      border-bottom: 0;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      padding-bottom: 1px;
      margin-bottom: -1px;
      background: #fff;
      font-size: 25px;
      align-items: center;
      justify-content: center;
    }
    .thumbnail-preview-container {
      position: relative;
      align-items: center;
      border-top: 1px solid #dfdfdf;
      //background: #fff;
      justify-content: center;
      &:empty {
        display: none;
      }
      &:hover {
        background: #bfe1ff;
      }
    }
    .footer-wrapper {
      max-height: 490px;
    }
    .icon-loading {
      display: none;
      background: #fff url(@/../assets/imgs/loading.svg) no-repeat center !important;
      background-size: 14px 14px !important;
      width: 20px !important;
      height: 20px !important;
      position: absolute;
      top: 0;
      left: 0;
      margin: 3px;
      overflow: hidden;
      border-radius: 50%;
    }
    .edit-mockup-form {
      position: absolute;
      bottom: 100%;
      left: 50%;
      width: 300px;
      background: #fff;
      box-shadow: 0 0 5px #666;
      padding: 7px;
      border-radius: var(--border-radius, 0.25rem);
      transform: translateX(-50%);
      z-index: 999999;
      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -7px;
        border-width: 7px;
        border-style: solid;
        border-color: #fff transparent transparent transparent;
        z-index: 9;
      }
      &:after {
        margin-left: -8px;
        border-width: 8px;
        border-color: #a7a7a7 transparent transparent transparent;
        z-index: 8;
      }
      .form-group {
        display: flex;
        margin-bottom: 0;
      }
      button {
        margin-left: 8px;
      }
    }
    label {
      margin: 0;
      padding: 0 5px;
      i {
        display: none;
      }
      &.latest {
        i.latest {
          color: #ff7700;
          display: inline-block;
        }
      }
      &.reject {
        i.reject {
          color: #d92550;
          display: inline-block;
        }
      }
    }
    .list-action {
      display: flex;
      position: absolute;
      z-index: 99;
      list-style: none;
      padding: 0;
      margin: 0;
      bottom: 5px;
      justify-content: center;
      width: 100%;
      li .icon {
        text-align: center;
        border: #e9ecef solid 1px;
        border-radius: var(--border-radius, 0.25rem);
        padding: 1px;
        z-index: 99;
        cursor: pointer;
        color: #333;
        background: #fff;
        width: 24px;
        height: 24px;
        margin: 1px;
        opacity: 0;
      }
    }
    .footer-wrapper:hover {
      .list-action {
        li .icon {
          opacity: 0.5;
        }
        &:hover {
          li .icon {
            opacity: 1;
          }
        }
      }
    }
    // .mockup-thumbnails {
    //   border-top: 1px solid #dfdfdf;
    //   .thumbnail-preview-container {
    //     border-top: 0 !important;
    //     align-items: center;
    //   }
    //   > div {
    //     width: auto;
    //     &:hover {
    //       background: #bfe1ff;
    //     }
    //   }
    // }
    &:hover {
      .toggle-collapse {
        display: flex;
      }
    }
  }
  .pull-down .scrollbar {
    display: none;
  }
  .main-thumbnail {
    flex: 1;
    height: 100px;
  }
  // .main-thumbnail {
  //   flex: 1;
  //   height: 100px;
  //   .font-icon-wrapper {
  //     display: flex;
  //     margin: 0;
  //     position: absolute;
  //     top: 10px;
  //     right: 10px;
  //     z-index: 99;
  //     cursor: pointer;
  //     opacity: 0.3;
  //     color: #333;
  //     &:hover {
  //       opacity: 1;
  //     }
  //   }
  // }
}
</style>
